// Статистика → План заказа (Алексей 27.10 #2972): тот же блок, что в Статусе, за период вкладки.
import useSWR from 'swr';
import { ServerStatusNotice } from '@/components/common/ServerStatusNotice';
import { Card, CardContent } from '@/components/ui/card';
import { getOrderPlan } from '@/api/orderPlan';
import { OrderPlanBlock } from './OrderPlanBlock';

/** Вкладка и панель в Статусе скрыты до доработки (Алексей 27.10 #2990/#2991). */
export const ORDER_PLAN_READY = false;

export default function OrderPlanTab({ zoneId, from, to }: { zoneId: string; from: string; to: string }) {
  const { data, error, isLoading } = useSWR(zoneId ? ['analytics:order-plan', zoneId, from, to] : null,
    () => getOrderPlan(zoneId, from, to).then((r) => r.data), { revalidateOnFocus: false });
  return (
    <Card>
      <CardContent className="px-4 py-4">
        <div className="mb-2 text-xs text-muted-foreground">Чего не хватило гостям: спросили у кассы, а позиции не было; жалобы в отзывах; заметки голосом «Линза, добавь в план заказа…» — справочно к заказу на следующий день.</div>
        {isLoading && !data && <div className="h-32 animate-pulse rounded-lg bg-muted" />}
        {error && !data && <ServerStatusNotice variant="card" error={error} />}
        {data && <OrderPlanBlock data={data} />}
      </CardContent>
    </Card>
  );
}
